import { render, staticRenderFns } from "./UserCardContactAddress.vue?vue&type=template&id=4733f627&scoped=true&"
import script from "./UserCardContactAddress.vue?vue&type=script&lang=ts&"
export * from "./UserCardContactAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4733f627",
  null
  
)

export default component.exports